import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import { FormControl, ControlLabel, Row, Col } from 'react-bootstrap';
import { ICreateOrderContact } from '../../Entities';
import ValidatableFormGroup from '../../../../components/common/ValidatableFormGroup';
import FieldInfoIcon from '../../../../components/common/FieldInfoIcon';
import CountryCodePhoneNumberInput from '../../../../components/common/CountryCodePhoneNumberInput';

interface ICreateOrderContactFormProps {
    contact: ICreateOrderContact;
    onDataChange: (e: any) => void;
    isFormValid: () => boolean;
    errors: any;
    isCommercial: boolean;
    areContactNamesRequired: boolean;
}

const CreateOrderContactForm = (props: ICreateOrderContactFormProps) => {
    return (
        <fieldset>
            {props.isCommercial && (
                <legend>{Translate('orders/create/form/header/owner-commercial')}</legend>
            )}
            {!props.isCommercial && (
                <legend>{Translate('orders/create/form/header/owner-private')}</legend>
            )}
            <form>
                <Row>
                    <Col sm={12} md={6}>
                        <ValidatableFormGroup
                            required={props.areContactNamesRequired}
                            validationKey="contact.OwnerFirstName"
                            errors={props.errors}
                        >
                            <ControlLabel>
                                {Translate('orders/create/form/input-label/owner-first-name')}
                            </ControlLabel>
                            <FormControl
                                type="text"
                                name="contact.ownerFirstName"
                                value={
                                    props.contact.ownerFirstName ? props.contact.ownerFirstName : ''
                                }
                                onChange={props.onDataChange}
                            />
                        </ValidatableFormGroup>
                    </Col>
                    <Col sm={12} md={6}>
                        <ValidatableFormGroup
                            required={props.areContactNamesRequired}
                            validationKey="contact.OwnerLastName"
                            errors={props.errors}
                        >
                            <ControlLabel>
                                {Translate('orders/create/form/input-label/owner-last-name')}
                            </ControlLabel>
                            <FormControl
                                type="text"
                                name="contact.ownerLastName"
                                value={
                                    props.contact.ownerLastName ? props.contact.ownerLastName : ''
                                }
                                onChange={props.onDataChange}
                            />
                        </ValidatableFormGroup>
                    </Col>
                    <Col sm={12}>
                        <ValidatableFormGroup
                            validationKey="contact.OwnerEmailAddress"
                            errors={props.errors}
                        >
                            <ControlLabel>
                                {Translate('orders/create/form/input-label/owner-email-address')}
                            </ControlLabel>
                            <FieldInfoIcon
                                title={Translate('popover/info/title/emailaddress')}
                                content={Translate('popover/info/content/emailaddress')}
                            />
                            <FormControl
                                type="text"
                                name="contact.ownerEmailAddress"
                                value={
                                    props.contact.ownerEmailAddress
                                        ? props.contact.ownerEmailAddress
                                        : ''
                                }
                                onChange={props.onDataChange}
                            />
                        </ValidatableFormGroup>
                    </Col>
                    <Col sm={12} md={6}>
                        <ValidatableFormGroup
                            validationKey="contact.ownerPrimaryPhoneNumber"
                            errors={props.errors}
                        >
                            <ControlLabel>
                                {Translate(
                                    'orders/create/form/input-label/owner-primary-phone-number'
                                )}
                            </ControlLabel>
                            <FieldInfoIcon
                                title={Translate('popover/info/title/phonenumber')}
                                content={Translate('popover/info/content/phonenumber')}
                            />
                            <CountryCodePhoneNumberInput
                                value={props.contact.ownerPrimaryPhoneNumber}
                                id="contact.ownerPrimaryPhoneNumber"
                                name="contact.ownerPrimaryPhoneNumber"
                                onChange={(val) =>
                                    props.onDataChange({
                                        target: {
                                            name: 'contact.ownerPrimaryPhoneNumber',
                                            value: val
                                        }
                                    })
                                }
                            />
                        </ValidatableFormGroup>
                    </Col>
                    {!props.isCommercial && (
                        <Col sm={12} md={6}>
                            <ValidatableFormGroup
                                validationKey="contact.ownerSecondaryPhoneNumber"
                                errors={props.errors}
                            >
                                <ControlLabel>
                                    {Translate(
                                        'orders/create/form/input-label/owner-secondary-phone-number'
                                    )}
                                </ControlLabel>
                                <FieldInfoIcon
                                    title={Translate('popover/info/title/phonenumber')}
                                    content={Translate('popover/info/content/phonenumber')}
                                />
                                <CountryCodePhoneNumberInput
                                    value={props.contact.ownerSecondaryPhoneNumber}
                                    onChange={(val) =>
                                        props.onDataChange({
                                            target: {
                                                name: 'contact.ownerSecondaryPhoneNumber',
                                                value: val
                                            }
                                        })
                                    }
                                />
                            </ValidatableFormGroup>
                        </Col>
                    )}
                </Row>
            </form>
        </fieldset>
    );
};

export default CreateOrderContactForm;
